"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Popover = exports.ALIGN_POSITIONS = void 0;
var _shared = require("@clayui/shared");
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _excluded = ["alignPosition", "children", "className", "closeOnClickOutside", "containerProps", "defaultShow", "disableScroll", "displayType", "header", "onOffset", "onShowChange", "show", "size", "trigger"];
/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var ALIGN_POSITIONS = exports.ALIGN_POSITIONS = ['top', 'top-left', 'top-right', 'bottom', 'bottom-left', 'bottom-right', 'left', 'left-top', 'left-bottom', 'right', 'right-top', 'right-bottom'];
var ALIGNMENTS_MAP = {
  bottom: ['tc', 'bc'],
  'bottom-left': ['tl', 'bl'],
  'bottom-right': ['tr', 'br'],
  left: ['cr', 'cl'],
  'left-bottom': ['br', 'bl'],
  'left-top': ['tr', 'tl'],
  right: ['cl', 'cr'],
  'right-bottom': ['bl', 'br'],
  'right-top': ['tl', 'tr'],
  top: ['bc', 'tc'],
  'top-left': ['bl', 'tl'],
  'top-right': ['br', 'tr']
};
var BOTTOM_OFFSET = [0, 4];
var LEFT_OFFSET = [-4, 0];
var RIGHT_OFFSET = [4, 0];
var TOP_OFFSET = [0, -4];
var OFFSET_MAP = {
  bctc: TOP_OFFSET,
  blbr: RIGHT_OFFSET,
  bltl: TOP_OFFSET,
  brbl: LEFT_OFFSET,
  brtr: TOP_OFFSET,
  clcr: RIGHT_OFFSET,
  crcl: LEFT_OFFSET,
  tcbc: BOTTOM_OFFSET,
  tlbl: BOTTOM_OFFSET,
  tltr: RIGHT_OFFSET,
  trbr: BOTTOM_OFFSET,
  trtl: LEFT_OFFSET
};
var Popover = exports.Popover = /*#__PURE__*/_react.default.forwardRef(function Popover(_ref, ref) {
  var _classNames;
  var _ref$alignPosition = _ref.alignPosition,
    alignPosition = _ref$alignPosition === void 0 ? 'bottom' : _ref$alignPosition,
    children = _ref.children,
    className = _ref.className,
    _ref$closeOnClickOuts = _ref.closeOnClickOutside,
    closeOnClickOutside = _ref$closeOnClickOuts === void 0 ? false : _ref$closeOnClickOuts,
    _ref$containerProps = _ref.containerProps,
    containerProps = _ref$containerProps === void 0 ? {} : _ref$containerProps,
    _ref$defaultShow = _ref.defaultShow,
    defaultShow = _ref$defaultShow === void 0 ? false : _ref$defaultShow,
    _ref$disableScroll = _ref.disableScroll,
    disableScroll = _ref$disableScroll === void 0 ? false : _ref$disableScroll,
    displayType = _ref.displayType,
    header = _ref.header,
    _ref$onOffset = _ref.onOffset,
    onOffset = _ref$onOffset === void 0 ? function (points) {
      return OFFSET_MAP[points.join('')];
    } : _ref$onOffset,
    onShowChange = _ref.onShowChange,
    show = _ref.show,
    size = _ref.size,
    trigger = _ref.trigger,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useControlledState = (0, _shared.useControlledState)({
      defaultName: 'defaultShow',
      defaultValue: defaultShow,
      handleName: 'onShowChange',
      name: 'show',
      onChange: onShowChange,
      value: show
    }),
    _useControlledState2 = _slicedToArray(_useControlledState, 2),
    internalShow = _useControlledState2[0],
    setShow = _useControlledState2[1];
  var triggerRef = (0, _react.useRef)(null);
  var popoverRef = (0, _react.useRef)(null);
  var popoverScrollerRef = (0, _react.useRef)(null);
  if (!ref) {
    ref = popoverRef;
  }
  var align = (0, _react.useCallback)(function () {
    if (ref.current && triggerRef.current) {
      var points = ALIGNMENTS_MAP[alignPosition];
      (0, _shared.doAlign)({
        offset: onOffset(points),
        points: points,
        sourceElement: ref.current,
        targetElement: triggerRef.current
      });
    }
  }, [alignPosition, triggerRef, ref]);
  (0, _react.useEffect)(function () {
    if (trigger) {
      align();
    }
  }, [align, internalShow]);
  (0, _react.useEffect)(function () {
    if (trigger && triggerRef.current) {
      return (0, _shared.observeRect)(triggerRef.current, align);
    }
  }, [align]);
  (0, _react.useEffect)(function () {
    if (!disableScroll && popoverScrollerRef.current && internalShow) {
      popoverScrollerRef.current.focus();
    }
    if (disableScroll && popoverRef.current && internalShow) {
      popoverRef.current.focus();
    }
  }, [disableScroll, popoverRef, popoverScrollerRef, internalShow]);
  (0, _react.useEffect)(function () {
    if (closeOnClickOutside && trigger) {
      var handleClick = function handleClick(event) {
        var nodeRefs = [popoverRef, popoverScrollerRef, triggerRef];
        var nodes = (Array.isArray(nodeRefs) ? nodeRefs : [nodeRefs]).filter(function (ref) {
          return ref.current;
        }).map(function (ref) {
          return ref.current;
        });
        if (event.target instanceof Node && !nodes.find(function (element) {
          return element.contains(event.target);
        })) {
          setShow(false);
        }
      };
      window.addEventListener('mousedown', handleClick);
      return function () {
        window.removeEventListener('mousedown', handleClick);
      };
    }
  }, [closeOnClickOutside, trigger]);
  (0, _react.useEffect)(function () {
    if (internalShow) {
      _shared.stack.push(popoverRef);
    }
    return function () {
      var index = _shared.stack.indexOf(popoverRef);
      if (index >= 0) {
        _shared.stack.splice(index, 1);
      }
    };
  }, [internalShow, popoverRef]);
  (0, _react.useEffect)(function () {
    var handleKeyDown = function handleKeyDown(event) {
      if (event.key === 'Escape' && _shared.stack[_shared.stack.length - 1] === popoverRef) {
        var _triggerRef$current;
        setShow(false);
        (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 ? void 0 : _triggerRef$current.focus();
      }
    };
    var onBlur = function onBlur(event) {
      if (popoverRef.current && !popoverRef.current.contains(event.relatedTarget)) {
        setShow(false);
      }
    };
    if (internalShow) {
      document.addEventListener('keydown', handleKeyDown);
      window.addEventListener('blur', onBlur);
      return function () {
        document.removeEventListener('keydown', handleKeyDown);
        window.removeEventListener('blur', onBlur);
      };
    }
  }, [internalShow]);
  var content = /*#__PURE__*/_react.default.createElement("div", _extends({
    className: (0, _classnames.default)(className, 'popover', "clay-popover-".concat(alignPosition), (_classNames = {}, _defineProperty(_classNames, "popover-".concat(displayType), displayType), _defineProperty(_classNames, 'popover-width-lg', size === 'lg'), _defineProperty(_classNames, "show", internalShow), _classNames)),
    ref: ref
  }, otherProps, {
    tabIndex: disableScroll ? -1 : undefined
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "arrow"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)({
      'inline-scroller': !disableScroll
    }),
    ref: popoverScrollerRef,
    tabIndex: !disableScroll ? -1 : undefined
  }, header && /*#__PURE__*/_react.default.createElement("div", {
    className: "popover-header"
  }, header), /*#__PURE__*/_react.default.createElement("div", {
    className: "popover-body"
  }, children)));
  if (trigger) {
    content = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.cloneElement(trigger, {
      onClick: function onClick(event) {
        if (trigger.props.onClick) {
          trigger.props.onClick(event);
        }
        setShow(!internalShow);
      },
      ref: function ref(node) {
        if (node) {
          triggerRef.current = node;
          // Call the original ref, if any.
          var _ref2 = trigger.ref;
          if (typeof _ref2 === 'function') {
            _ref2(node);
          } else if (_ref2) {
            _ref2.current = node;
          }
        }
      }
    }), internalShow && /*#__PURE__*/_react.default.createElement(_shared.ClayPortal, containerProps, content));
  }
  return content;
});
Popover.displayName = 'ClayPopover';